import type { Tokens } from '../../../../theming/types'
import type { ModalCloseProps } from '..'

export default (config: {
  props: Pick<ModalCloseProps, 'dark'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    wrap: {
      '> button': {
        // TODO: Update with tokens
        backgroundColor: props.dark
          ? 'rgba(26, 29, 32, 0.65)'
          : 'rgba(255, 255, 255, 0.7)',
        borderRadius: '50%',

        '&:hover': {
          // TODO: Update with tokens
          backgroundColor: props.dark
            ? 'rgba(26, 29, 32, 0.75)'
            : tokens.ctaBgColorTertiaryHover,
        },
      },
    },
  } as const
}
